import Vue from 'vue'
import VueRouter from 'vue-router'
import Search from '../views/Search.vue'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import store from '../store'

Vue.use(VueRouter)

const routes = [
    {
        path: '/user-login',
        component: Login,
        meta: { disallowAuthed: true }
    },
    {
        path: '/register',
        component: () => import('../views/Register.vue')
    },
    {
        path: '/',
        component: Home,
        meta: {
            requiresAuth: true
        },
        children: [
            {
                path: '/',
                component: Search
            },
            {
                path: '/casereport',
                name: 'casereport',
                component: () => import('../views/CaseReportFullScreen.vue'),
                props: (route) => (
                    route.params
                )
            },
            {
                path: '/resolution',
                component: () => import('../views/Resolution.vue')
            },
            {
                path: '/help',
                component: () => import('../views/Help.vue')
            },
            {
                path: '/history',
                component: () => import('../views/History.vue')
            },
            {
                name: "caseReportCsv",
                path: "api/reports/csv/history/casereports"
            },
            {
                name: "historyCsv",
                path: "api/reports/csv/history"
            },
            {
              name: "casesCsv",
              path: "api/reports/csv/cases"
            },
            {
                path: '/settings',
                component: () => import('../views/Settings.vue'),
                children: [
                    {
                        path: '/',
                        component: () => import('../views/settings/Profile.vue')
                    },
                    {
                        path: '/users',
                        component: () => import('../views/settings/Users.vue')
                    },
                    {
                        path: '/account',
                        component: () => import('../views/settings/Account.vue')
                    },
                    {
                        path: '/invoices',
                        component: () => import('../views/settings/Invoices.vue')
                    },
                    
                    {
                        path: '/compliance',
                        component: () => import('../views/settings/Compliance.vue')
                    }
                ]
            },
            {
                path: '/casegroups',
                component: () => import('../views/CaseGroups.vue')
            },
            {
                path: '/casemanager',
                component: () => import('../views/CaseManager.vue')
            }
        ]
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

router.beforeEach((to, from, next) => {

    // clears any global alerts
    store.dispatch('setGlobalAlert', {
        alert: false,
        color: '',
        alertTitle: '',
        alertMessage: ''
    })

    const loggedIn = !!store.getters.isAuthenticated
    if (loggedIn && to.meta.disallowAuthed) {
        return router.push("/")
    }
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!loggedIn) {
            next('/user-login')
        } else {
            next()
        }
    } else {
        next()
    }
})

export default router